
import checkin from "@/components/work/checkin";
import checkinDriver from "@/components/work/checkinDriver";
import carWork from "@/components/work/carWork";
import carWorks from "@/components/work/carWorks";
import areaWorks from "@/components/work/areaWorks";
import personUnqualified from "@/components/work/personUnqualified";
import lineWorks from "@/components/work/lineWorks";
import personWork from "@/components/work/personWork";
import carNoWork from "@/components/work/carNoWork";
import PersonQualified from "@/components/work/PersonQualified";
var data = [
  {
    path: "/checkin",
    component: checkin
  },
  {
    path: "/checkinDriver",
    component: checkinDriver
  },
  {
    path: "/carWork",
    component: carWork
  },
  {
    path: "/carWorks",
    component: carWorks
  },
  {
    path: "/areaWorks",
    component: areaWorks
  },
  {
    path: "/lineWorks",
    component: lineWorks
  },
  {
    path: "/PersonQualified",
    component: PersonQualified
  },
  {
    path: "/personUnqualified",
    component: personUnqualified
  },
  {
    path: "/carNoWork",
    component: carNoWork
  },
  {
    path: "/personWork",
    component: personWork
  }
];
export default data;



// WEBPACK FOOTER //
// ./src/router/work.js